/**
 * Tira de chips com o que vale no dia além dos agendamentos: reservas da
 * secretária (âmbar, fora do portal) e bloqueios manuais (vermelho, com o
 * motivo). Vai no topo da visão Dia (linha do tempo E lista de cards) e no
 * rail "Agenda do dia" — lugares em que a banda pintada na grade não
 * aparece ou passa despercebida. Faixa "Não liberado" NÃO entra: ela já
 * tem banner próprio e, no modo por liberação, estaria em todo dia.
 */
import { Ban, Lock } from 'lucide-react';
import { type BlockedRange, type ReleasedRange, UNRELEASED_REASON } from '@/utils/blockedDates';

const txt = (r: { start: string; end: string; full: boolean }) => (r.full ? 'dia inteiro' : `${r.start}–${r.end}`);

export const DayRangesStrip = ({
  reserved,
  blocked,
  className = '',
  dense = false,
}: {
  reserved?: ReleasedRange[];
  blocked?: BlockedRange[];
  className?: string;
  /** Rail lateral: chips menores. */
  dense?: boolean;
}) => {
  const res = reserved ?? [];
  const blk = (blocked ?? []).filter((b) => b.reason !== UNRELEASED_REASON);
  if (res.length === 0 && blk.length === 0) return null;
  const size = dense ? 'text-[10px] px-1.5 py-0.5' : 'text-[11px] px-2 py-1';
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`} data-testid="day-ranges-strip">
      {res.map((r, i) => (
        <span
          key={`res-${i}`}
          className={`inline-flex items-center gap-1 rounded-md font-semibold bg-warning/15 text-warning border border-warning/30 ${size}`}
          title="Reserva da secretária — não aparece no portal"
        >
          <Lock size={dense ? 9 : 11} /> Reserva {txt(r)}
          {!dense && <span className="font-normal opacity-80">· só secretária</span>}
        </span>
      ))}
      {blk.map((b, i) => (
        <span
          key={`blk-${i}`}
          className={`inline-flex items-center gap-1 rounded-md font-semibold bg-error/10 text-error border border-error/30 ${size}`}
          title={b.reason ? `Bloqueado ${txt(b)} — ${b.reason}` : `Bloqueado ${txt(b)}`}
        >
          <Ban size={dense ? 9 : 11} /> Bloqueado {txt(b)}
          {b.reason && <span className="font-normal opacity-80 truncate max-w-[14rem]">· {b.reason}</span>}
        </span>
      ))}
    </div>
  );
};
